import { Injectable, inject, signal, computed } from '@angular/core';
import { BehaviorSubject } from "rxjs";
import { TranslateService } from '@ngx-translate/core';

export interface Languages {
    languageName: string,     //'English'
    languageCode: string  //'en'
}

@Injectable({
    providedIn: 'root'
})
export class LanguageService {
    private translate = inject(TranslateService);
    
    // Signal-based state management
    private _availLang = signal<Languages[]>([
        {languageName: 'English', languageCode: 'en'},
        {languageName: 'Español', languageCode: 'es'}
    ]);
    private _currentLanguage = signal<Languages>(this._availLang()[0]);
    
    // Computed properties
    availLang = computed(() => this._availLang());
    currentLanguage = computed(() => this._currentLanguage());
    
    // Keep BehaviorSubject for backward compatibility
    private languageStore = new BehaviorSubject<any>(this._availLang()[0]);
    language$ = this.languageStore.asObservable();

    constructor() {
        this.translate.addLangs(['en', 'es']);
        this.translate.setDefaultLang('en');
    }

    getLanguage(): Languages {
        return this._currentLanguage();
    }
    
    setLanguage(languageCode: string): void {
        let nextLanguage = this._availLang().find(lang => lang.languageCode === languageCode);
        if (!nextLanguage) {
            nextLanguage = this._availLang().find(lang => lang.languageCode === 'en');
        }
        
        this._currentLanguage.set(nextLanguage);
        this.languageStore.next(nextLanguage);

        this.translate.use(languageCode);
        localStorage.setItem('language', languageCode);
    }

    getTranslation(jsonKey: string): string {
        return this.translate.instant(jsonKey);
    }
}
